import { createElement, useContext } from 'react';

interface MakeContextHocArgs<C extends {}, K extends string = 'ctx'> {
    propName: K;
    context: React.Context<C>;
}

function makeContextHoc<C, K extends string = 'ctx'>(
    args: MakeContextHocArgs<C, K>
) {
    const { context, propName = 'ctx' } = args;

    const withContext = <P extends { [key in K]: C }>(
        Component: React.ComponentType<P>
    ) => {
        const BoundComponent = (props: Pick<P, Exclude<keyof P, K>>) => {
            const ctx = useContext(context);

            return createElement(Component, {
                ...(props as P),
                [propName]: ctx,
            });
        };

        return BoundComponent;
    };

    return withContext;
}

export default makeContextHoc;
